export const STRING_SHORT_MAX_LENGTH = 50;
export const STRING_LONG_MAX_LENGTH = 255;
export const STRING_SUPPORT_MAX_LENGTH = 1000;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 50;
